export const natureTypes = [
  {
    type: "task-project-ing-visit",
    label: "Toutes les visites",
  },
  {
    type: "task-project-ing-visit-extra",
    label: "Visite de l'ingénieur (support)",
  },
  {
    type: "task-project-ing-pri",
    label: "Validation du principe structure",
  },
  {
    type: "task-project-ing-pri-extra",
    label: "Validation du principe structure (support)",
  },
  {
    type: "task-project-ing-study",
    label: "Réalisation du dossier d'étude",
  },
  {
    type: "task-project-ing-study-extra",
    label: "Réalisation du dossier d'étude (support)",
  },
  {
    type: "task-project-ing-study-check",
    label: "Vérification du dossier d'étude",
  },
  {
    type: "task-project-ing-study-check-extra",
    label: "Vérification du dossier d'étude (support)",
  },
  {
    type: "task-project-ing-manager",
    label: "Manager",
  },
  {
    type: "task-project-ing-manager-extra",
    label: "Manager (support)",
  },
  {
    type: "task-project-ing-study-fix",
    label: "Demande correction",
  },
  {
    type: "task-project-ing-study-fix-extra",
    label: "Demande correction (support)",
  },
  {
    type: "task-project-ing-writing",
    label: "Rédaction dossier d'étude structure",
  },
  {
    type: "task-project-ing-measure",
    label: "Dimensionnement",
  },
  {
    type: "task-project-ing-projecting",
    label: "Projetage",
  },
  {
    type: "task-project-ing-meeting",
    label: "Échange client",
  },
  {
    type: "task-project-ing-analyse",
    label: "Prise de connaissance projet",
  },
  {
    type: "task-project-ing-supervision",
    label: "Visite de suivi de travaux",
  },
  {
    type: "task-project-ing-additional-request",
    label: "Demande complémentaire",
  },
  {
    type: "task-project-ing-customer-service",
    label: "Service Après-Vente (SAV)",
  },
  {
    type: "task-project-ing-travel",
    label: "Déplacement",
  },
  {
    type: "task-day-off",
    label: "Journée d'absence Lucca",
  },
];
